import { useQuery } from '@apollo/client'
import {
  InsuranceCompanies,
  InsuranceCompaniesVariables,
  InsuranceCompanyFilterInput,
} from '../../types'
import { INSURANCE_COMPANIES } from './operations'

interface Props {
  filter: InsuranceCompanyFilterInput
  page: number
  pageLength: number
}

export const useInsuranceCompanies = ({ filter, page, pageLength }: Props) =>
  useQuery<InsuranceCompanies, InsuranceCompaniesVariables>(INSURANCE_COMPANIES, {
    variables: {
      filterData: {
        ...filter,
      },
      pagination: {
        from: pageLength * (page - 1),
        length: pageLength,
      },
    },
  })
